import { useMemo } from "react";
import { useCustomersIndividualFormRules } from "../../../../../../../../../lib/hooks/useCustomersIndividualFormRules";
import { useCompanyNameRules } from "../../../../../../../../../lib/hooks/useCompanyNameRules";

export const useReceiverFormOptions = (isIndividual: boolean) => {
  const { formOptions: formOptionsIndividual } =
    useCustomersIndividualFormRules(true, "receiver");

  const { rules } = useCompanyNameRules();

  const formOptionsCompany = useMemo(() => {
    return [
      {
        label: "Company Name",
        name: ["receiver", "companyName"],
        rules,
      },
    ];
  }, [rules]);

  const formOptions = useMemo(() => {
    return isIndividual ? formOptionsIndividual : formOptionsCompany;
  }, [formOptionsCompany, formOptionsIndividual, isIndividual]);

  return { formOptions };
};
